import gql from 'graphql-tag'

export const SchoolReviewFieldsFragment = gql`
  fragment SchoolReviewFields on SchoolReview {
    id
    rating
    message
    submittedAt
  }
`
